import { useMediaQuery } from 'shared/hooks/dom';

import { Wrapper } from './components/Wrapper';

import type { TooltipProps } from './types';
import type { FC } from 'react';

export const TOOLTIP_TEST_ID = 'tooltip';

export const Tooltip: FC<TooltipProps> = ({ children, ...props }) => {
  const matches = useMediaQuery('md');

  return (
    <Wrapper
      data-testid={TOOLTIP_TEST_ID}
      placement={matches ? 'right' : 'top'}
      arrow
      {...props}
    >
      {children}
    </Wrapper>
  );
};
